module.exports = __webpack_public_path__ + "img/top5.ff9ebdff.png";